import { render, staticRenderFns } from "./sign.vue?vue&type=template&id=04b13754&scoped=true&"
import script from "./sign.vue?vue&type=script&lang=js&"
export * from "./sign.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/app.css?vue&type=style&index=0&id=04b13754&prod&scoped=true&lang=css&"
import style1 from "./sign.vue?vue&type=style&index=1&id=04b13754&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b13754",
  null
  
)

export default component.exports